import { render, staticRenderFns } from "./ProductTemplateBuilderOverlay.vue?vue&type=template&id=11b1eca3&scoped=true"
import script from "./ProductTemplateBuilderOverlay.vue?vue&type=script&lang=js"
export * from "./ProductTemplateBuilderOverlay.vue?vue&type=script&lang=js"
import style0 from "./ProductTemplateBuilderOverlay.vue?vue&type=style&index=0&id=11b1eca3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1eca3",
  null
  
)

export default component.exports